import type { ButtonProps } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../shared/components/AppButton";
import { CopyIcon } from "../../../../../shared/icons/CopyIcon";
import styles from "../styles.module.css";
import type { SidebarButtonSize } from "../types";

interface Props extends ButtonProps {
  handleCopyObject?: () => void;
  buttonSize?: SidebarButtonSize;
}

export const CopyObjectButton: FC<Props> = ({
  handleCopyObject,
  buttonSize,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <AppButton
      buttonType={"text"}
      onClick={handleCopyObject}
      icon={<CopyIcon />}
      className={classNames(styles.button, {
        [styles["pd.block-16"]]: buttonSize === "middle",
        [styles["pd.block-10"]]: buttonSize === "small",
      })}
      {...props}
    >
      {t("sidebar.copy_object_button")}
    </AppButton>
  );
};
